import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { selectWorks } from '../../../Api/selectors';
import { selectCompany, selectNewCompany } from '../../selectors';
import { createCompany, addUserToCompany, deleteUserFromCompany } from '../../actions';
import { REQUEST_COMPANY, REQUEST_COMPANY_ADD_USER, REQUEST_COMPANY_DELETE_USER_FROM_COMPANY } from '../../constants';
import { Loader } from '../../../../components/Loader';
import { CompanyUsers } from '../../components/CompanyUsers';
import { Button } from '../../../../components/Buttons';
import styles from './ThirdStep,module.css';
import cn from 'classnames';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

const Container = styled.div`
  width: 100%;
  .cols {
  }
  .col {
    min-width: 400px;
    padding-right: 48px;
    @media (max-width: 768px) {
      width: 100%;
      min-width: 250px;
    }
  }

  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin: 6px;
    }
    .col {
      @media (max-width: 768px) {
        width: 100%;
        min-width: 200px;
      }
    }
  }

  .vies-block {
    overflow-y: auto;
    width: 100%;
    max-height: 250px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
  }

  .button-block {
    margin: -6px;
    margin-right: 15px;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class CompanyCreateStep3Comp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  create() {
    this.props.create(this.properties, this.options, result => {
      this.to(`/vehicles/${result.id}`);
    });
  }

  save() {
    this.props.onSave();
  }

  prevStep() {
    this.props.getPrevStep();
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container className={styles.container}>
         <HBox left className={styles.titleCompany}><h5>{this.props.values.name}</h5></HBox>
         
        <CompanyUsers company={this.props.company} editCompany="editCompany" allowRemove></CompanyUsers>

        <div className="d-flex gap-2 justify-content-end mt-2 mb-3">
          <ButtonComponent style="ButtonSoftPrimary" onClick={this.prevStep.bind(this)}>
            {this.lbl('previous')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftEdit" onClick={this.save.bind(this)} small>
            {this.lbl('save')}
          </ButtonComponent>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    company: selectCompany(ownProps.company_id),
    work: selectWorks([REQUEST_COMPANY, REQUEST_COMPANY_DELETE_USER_FROM_COMPANY, REQUEST_COMPANY_ADD_USER]),
    values: selectNewCompany(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(properties, options, callback) {
      dispatch(createCompany(properties, options, callback));
    },
    addUserToCompany(companyId, userId) {
      dispatch(addUserToCompany(companyId, userId));
    },
    removeUserFromCompany(companyId, userId) {
      dispatch(deleteUserFromCompany(companyId, userId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyCreateStep3 = compose(withConnect, withRouter)(CompanyCreateStep3Comp);
